// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//兼容IE
import 'babel-polyfill';
import promise from 'es6-promise';
promise.polyfill();

import Vue from 'vue';
import store from './store/store.js';
import App from './App';
import router from './router';
import MuseUI from 'muse-ui';
import 'muse-ui/dist/muse-ui.css';//https://muse-ui.org/#/zh-CN
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
import API from '@/router/url_itembox.js';
import qs from 'qs';
import VueJsonp from 'vue-jsonp';





Vue.prototype.qs = qs;
Vue.prototype.axios = axios;
Vue.prototype.$http = axios;
Vue.prototype.$qs = qs;
Vue.prototype.$axios = axios;

Vue.use(MuseUI);
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.use(VueJsonp);

window.API = API;
// Vue.prototype.$post=post;
// Vue.prototype.$fetch=fetch;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js